import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useBreakPoint } from '@repo/toolkit/use-break-point'
import { LoginGroupFiveIcon, Logo } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

const ClientAuthVariant = () => {
  const device = useBreakPoint()
  const isMobile = device === 'mobile'

  return (
    <div className="w-full h-full bg-cover bg-center bg-no-repeat  bg-[url('/client-auth.png')] mobile:bg-[url('/client-mobile.png')]">
      <div className="flex flex-col items-end w-fit pt-20">
        <div className="flex flex-col items-start w-fit mobile:mx-6">
          <Logo text="Séjours Linguistiques" className={cn('w-28 h-28 mobile:w-20 mobile:h-20')} />
          {isMobile && (
            <Typography variant="h2" color={tailwindColors.white.DEFAULT}>
              Bienvenue sur votre Espace Personnel LEC !
            </Typography>
          )}
        </div>
        {!isMobile && (
          <LoginGroupFiveIcon color={tailwindColors.white.DEFAULT} className="-ml-1" />
        )}
      </div>
      {!isMobile && (
        <Typography
          variant="h2"
          color={tailwindColors.white.DEFAULT}
          className="w-1/2 text-left mx-auto mt-20 ml-20"
        >
          Bienvenue sur votre Espace Personnel LEC !
        </Typography>
      )}
    </div>
  )
}

export default ClientAuthVariant
